import { Component } from '@angular/core';
import { MenuService } from '../../services/menu.service';
import { MenuItem } from '../../services/menu.types';
import { Router } from '@angular/router';
import { AuthService } from '../../../auth/services/auth.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss'
})
export class SidebarComponent {
  menus$ = this.menuService.menus$; // Observable para los menús
  isSidebarOpen$ = this.menuService.sidebarOpen$; // Observable para el estado del sidebar

  constructor(private menuService: MenuService, private router: Router, private authService:AuthService) {}

  toggleSubmenu(menu: MenuItem): void {
    menu.collapsed = !menu.collapsed; // Alterna el estado colapsado
  }

  navigateTo(menu: MenuItem): void {
    if (menu.route) {
      this.router.navigate([menu.route]);
    } else {
      console.warn('Este menú no tiene ruta asignada.');
    }
  }

  logout(): void {
    this.authService.logout();
    this.menuService.reset(); // si usas reset para limpiar menú
    this.router.navigate(['/login']);
  }
}
